import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-health-subscribe',
  templateUrl: './health-subscribe.component.html',
  styleUrls: ['./health-subscribe.component.scss']
})
export class HealthSubscribeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
